<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><strong>To every one of us who ever said,<br/>“Let me try again, just one more time.”</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?41adc6c8